import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'keys',
    standalone: false
})
export class KeysPipe implements PipeTransform {

  transform(value?: string, ...args: unknown[]): unknown {
    if(value == null)
      return "null";

    return Object.keys(value);
  }

}
